import Acquaintence from './Acquaintence'

export default Acquaintence